<template>
 

    <v-layout wrap>
      <v-flex lg4 md4 sm4>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="subjectOption"
              :series="subjectSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 md4 sm4>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="chapterOption"
              :series="chapterSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 md4 sm4>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="lectureOption"
              :series="lectureSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
      
      <v-flex lg4 md4 sm4>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="courseDurationOptions"
              :series="courseDurationSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
      <v-flex md4 sm6 lg3>
        <v-card>
          <div id="chart">
            <apexchart
              type="pie"
              :options="isFreeOptions"
              :series="isFreeSeries"
            />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import firebase from "firebase/app";
import bus from "../bus";
import { deviceRef, userSessionRef, streamingVideosRef } from "../firebase";
import { setTimeout } from 'timers';
import { mapGetters, mapActions, mapState } from "vuex";

import Pusher from 'pusher-js'
const socket = new Pusher('8b7b2278694ce750e2e5', {
  cluster: 'mt1',
  encrypted: true
})
const channel = socket.subscribe('newLecture')


export default {


  components: {
    apexchart: VueApexCharts
  },
  firebase: {
    devices: deviceRef
  },
  
  computed: {
    ...mapState('dashboard', ['isFreeSeries', 'isFreeOptions', 'courseDurationSeries', 'courseDurationOptions',
    'lectureCountList', 'courseList', 'lectureOption', 'lectureSeries', 'subjectOption', 'subjectSeries', 'chapterOption', 'chapterSeries', 'liveStreamingNumber']),
  },
  data() {
    return {
      devices: [],
      valueLive: [],
      users: [],
      streamingVideos: [],
      options: {
        chart: {
          id: "bar-chart"
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
          categories: ['Users', 'Devices', 'Live Streaming']
        }
      },
      series: [
        {
          name: "Device graph",
          data: []
        }
      ],

      pie_series: [45, 55, 70],
      chartOptions: {
        labels: ["Female", "Male", "Not mentioned", ],
        theme: {
          monochrome: {
            enabled: true
          }
        },
        title: {
          text: "Number of leads"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      }
    };
  },
  watch: {
 
  },
  created() {
  let self = this
  channel.bind('lecture-created', function (data) {
      console.log(data);
      self.getLecturesNumberForLMS()
      self.getLecturesNumberByFree()
      self.getLecturesSumForLMS()
      // this.valueLive = 3
    });
  this.getLecturesNumberForLMS()
  this.getSubjectNumberByCourse()
  this.getChapterNumberByCourse()
  this.getLecturesNumberByFree()
  this.getLecturesSumForLMS()
  },
  methods: {
    ...mapActions("dashboard", ["getLecturesNumberForLMS", 'setLiveStreamingNumber', 'getSubjectNumberByCourse', 'getChapterNumberByCourse', 'getLecturesNumberByFree', 'getLecturesSumForLMS']),

  }
};
</script>
